<template>
  <div class="html">
    <div class="head" style="height: 140px">
      <div class="w1200">
        <div class="logo fl" :style="'background-image:url(' + configure.logo1 + ')'">
          <router-link to="/"></router-link>
        </div>
        <el-input placeholder="请输入专题名称" v-model="input4" class="fl">
          <i slot="suffix" @click="goSpecial" style="color: #0096ff; cursor: pointer" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-button type="text" class="fl" @click="$router.push({ name: 'my' })" style="margin-right: 15px"><i class="iconfont icontouxiang"></i>我的资源</el-button>
        <el-button type="text" class="fl" @click="$router.push({ name: 'resourceUpload' })"><i class="iconfont iconshangchuan-01"></i>上传资源</el-button>
        <el-button type="text" class="fl countBtn" v-if="auditRole" @click="$router.push({ name: 'audit' })"><i class="el-icon-tickets"></i> <span
                class="count">{{count}}</span>
          待审批
        </el-button>
        <div class="cl"></div>
      </div>
      <div class="bg">
        <div class="w1200">
          <div class="nav1">
            <ul>
              <li>
                <router-link to="/">首页</router-link>
              </li>
              <li :class="$route.path.split('/')[1] == 'resource' ? 'on' : ''">
                <router-link to="/resource">资源中心</router-link>
              </li>
              <!-- <li><router-link to="">题库组卷</router-link></li> -->
              <li :class="$route.path.split('/')[1] == 'special' ? 'on' : ''">
                <router-link to="/special">专题资源</router-link>
              </li>
              <li :class="$route.path.split('/')[1] == 'classroom' ? 'on' : ''">
                <router-link to="/classroom">三师课堂</router-link>
              </li>
              <li :class="$route.path.split('/')[1] == 'statistics' ? 'on' : ''">
                <router-link to="/statistics">统计中心</router-link>
              </li>
              <li>
                <a :href="configure.helpUrl" target="_blank">帮助中心</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="main">
      <router-view ref="special" :name1="input4"></router-view>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return { input4: "", count: "" };
  },
  computed: {
    ...mapState(["userModule"]),
    ...mapState(["configure"]),
    auditRole() {
      // let role = ["Admin", "AreaManager", "Auditor", "ThirdResourceManager"]; //超管\区管\资源中心审核员\三师资源审核员
      let roleCode = this.userModule.roles.map((item) => item.roleCode);
      //0没有权限，1超管、区管、资源&&三师审核员，2资源中心审核员，3三师资源审核员
      if (
        roleCode.includes("Admin") ||
        roleCode.includes("AreaManager") ||
        (roleCode.includes("Auditor") &&
          roleCode.includes("ThirdResourceManager"))
      ) {
        return 1;
      } else if (roleCode.includes("Auditor")) {
        return 2;
      } else if (roleCode.includes("ThirdResourceManager")) {
        return 3;
      } else {
        return 0;
      }
    },
  },
  mounted() {
    this.getCount();
  },
  methods: {
    getCount() {
      this.$ajax
        .post("/server/third/resource/approval/count/toAudit")
        .then((res) => {
          if (this.auditRole == 1) {
            this.count = res.countResource + res.countThird;
          } else if (this.auditRole == 2) {
            this.count = res.countResource;
          } else if (this.auditRole == 3) {
            this.count = res.countThird;
          } else {
            this.count = 0;
          }
        });
    },
    goSpecial() {
      if (this.$route.name == "special") {
        this.$refs.special.getData(1);
      } else {
        this.$router.push({ name: "special", params: { name: this.input4 } });
      }
    },
  },
};
</script>

<style scoped>
.countBtn {
  position: relative;
}
.count {
  position: absolute;
  /* top: 10px;
  right: -30px; */
  background-color: #f56c6c;
  border-radius: 10px;
  color: #fff;
  display: inline-block;
  font-size: 12px;
  height: 18px !important;
  line-height: 18px !important;
  padding: 0 6px;
  text-align: center;
  white-space: nowrap;
  border: 1px solid #fff;
  transform: translateY(-50%) translateX(100%);
}
</style>



// WEBPACK FOOTER //
// src/page/indexSpecial.vue